export const DEFAULT_SCOPES = [
  `api://${import.meta.env.VITE_OIDC_APPLICATION_ID}/Api.Access`,
];
